import { useContext, useEffect, useState } from "react";
import Loading from "../components/Loading";
import ReactPaginate from "react-paginate";
import { Context } from "../context/MainContext";
import { toast } from "react-toastify";
import { fetchDashboardCount, fetchUsers } from "../api/dashboardApi";

const Dashboard = () => {
  const { user } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [loadingCount, setLoadingCount] = useState(false);
  const [count, setCount] = useState(null);
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  const handlePageClick = (event) => {
    setPage(event.selected + 1);
    if (searchQuery) {
      handleSearch();
    }
  };

  const handleSearch = async () => {
    if (searchQuery && user?.id) {
      setLoading(true);
      try {
        // const res = await fetchUsersBySearch(
        //   searchQuery,
        //   user?.accessToken,
        //   page
        // );

        // setUsers(res.data);
        // setPageCount(res.data.totalPages);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        const message =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          err.toString();
        toast.error(message);
      }
    }
  };

  useEffect(() => {
    const handleFetchUsers = async () => {
      if (user?.id && searchQuery === "") {
        setLoading(true);
        try {
          const res = await fetchUsers(page);

          setUsers(res.data);
          setPageCount(res.data.totalPages);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          const message =
            (err.response && err.response.data && err.response.data.message) ||
            err.message ||
            err.toString();
          toast.error(message);
        }
      }
    };

    handleFetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, page]);

  useEffect(() => {
    const handleFetchCount = async () => {
      if (user?.id) {
        setLoadingCount(true);
        try {
          const res = await fetchDashboardCount();
          setCount(res.data);
          setLoadingCount(false);
        } catch (err) {
          setLoadingCount(false);
          const message =
            (err.response && err.response.data && err.response.data.message) ||
            err.message ||
            err.toString();
          toast.error(message);
        }
      }
    };

    handleFetchCount();
  }, [user?.id]);

  return (
    <div className="Dashboard">
      {loadingCount ? (
        <Loading />
      ) : (
        <div className="dashboard__top">
          <div className="dashboard__top__card">
            <div className="dashboard__top__card__left">
              <h4>Total Blogs</h4>
              <p>{count?.blogCount}</p>
              {/* <span>
                <span className="suc">3.48%</span> (Since last month)
              </span> */}
            </div>
            <i className="ti-file"></i>
          </div>
          <div className="dashboard__top__card">
            <div className="dashboard__top__card__left">
              <h4>Total Orders</h4>
              <p>{count?.orderCount}</p>
              {/* <span>
                <span className="suc">3.48%</span> (Since last month)
              </span> */}
            </div>
            <i className="ti-file"></i>
          </div>

          <div className="dashboard__top__card">
            <div className="dashboard__top__card__left">
              <h4>Total Products</h4>
              <p>{count?.productCount}</p>
              {/* <span>
                <span className="suc">3.48%</span> (Since last month)
              </span> */}
            </div>
            <i className="ti-file"></i>
          </div>
          <div className="dashboard__top__card">
            <div className="dashboard__top__card__left">
              <h4>Total Users</h4>
              <p>{count?.userCount}</p>
              {/* <span>
                <span className="suc">3.48%</span> (Since last month)
              </span> */}
            </div>
            <i className="ti-file"></i>
          </div>
        </div>
      )}

      <div className="dashboard__users">
        <div className="dashboard__users__top">
          <h3>USERS</h3>
          {/* <div className="topbar__left__input">
            <input
              placeholder="Search by Name and ID"
              type="text"
              onChange={(e) => setSearchQuery(e.target.value)}
              value={searchQuery}
            />
            <i className="ti-search"></i>

          </div> */}
          {/* <button onClick={handleSearch}>
            </button> */}
        </div>
        <div className="dashboard__users__table">
          <div className="dashboard__users__table__body">
            <div className="dashboard__users__table__row head">
              <div
                style={{ width: "30px" }}
                className="dashboard__users__table__row__head"
              >
                s/n
              </div>
              <div
                style={{ width: "400px" }}
                className="dashboard__users__table__row__head"
              >
                User Id
              </div>
              <div
                style={{ width: "100px" }}
                className="dashboard__users__table__row__head"
              >
                First name
              </div>
              <div
                style={{ width: "100px" }}
                className="dashboard__users__table__row__head"
              >
                Last name
              </div>
              <div
                style={{ width: "100px" }}
                className="dashboard__users__table__row__head"
              >
                Role
              </div>
              <div
                style={{ width: "250px" }}
                className="dashboard__users__table__row__head"
              >
                Email
              </div>
            </div>

            {loading ? (
              <Loading />
            ) : (
              users?.users?.map((user, i) => {
                return (
                  <div key={user.id} className="dashboard__users__table__row">
                    <div
                      style={{ width: "30px" }}
                      className="dashboard__users__table__row__data"
                    >
                      {(page - 1) * 10 + (i + 1)}
                    </div>
                    <div
                      style={{ width: "400px" }}
                      className="dashboard__users__table__row__data"
                    >
                      {user.id}
                    </div>
                    <div
                      style={{ width: "100px" }}
                      className="dashboard__users__table__row__data"
                    >
                      {user?.firstName}
                    </div>
                    <div
                      style={{ width: "100px" }}
                      className="dashboard__users__table__row__data"
                    >
                      {user?.lastName}
                    </div>
                    <div
                      style={{ width: "100px" }}
                      className="dashboard__users__table__row__data"
                    >
                      {user?.role}
                    </div>
                    <div
                      style={{ width: "250px" }}
                      className="dashboard__users__table__row__data"
                    >
                      {user?.email}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>

      {pageCount > 1 && (
        <div style={{ marginTop: 40 }}>
          <ReactPaginate
            previousLabel={"<"}
            nextLabel={">"}
            pageCount={pageCount}
            breakLabel="..."
            // renderOnZeroPageCount={null}
            onPageChange={handlePageClick}
            // pageRangeDisplayed={itemsPerPage}
            containerClassName={"paginationBttns"}
            previousLinkClassName={"previousBttn"}
            nextLinkClassName={"nextBttn"}
            disabledClassName={"paginationDisabled"}
            activeClassName={"paginationActive"}
          />
        </div>
      )}
    </div>
  );
};

export default Dashboard;
